<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="ENCERRAMENTO CONTABIL" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
          image-title="assets/img/choice.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <a [routerLink]="['/']" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
        <button *ngIf="podeIncluir()" [disabled]="!mesSelect" (click)="submitForm()" style="font-size: 13px;"
          class="btn btn-info btn-sm float-right mr-2">Salvar</button>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <ul class="nav nav-tabs" id="myTab" role="tablist" style="font-size: 13px;">
      <li class="nav-item">
        <a class="nav-link active" id="encerramento-tab" data-toggle="tab" href="#encerramento" role="tab"
          aria-controls="encerramento" aria-selected="true">Encerramento Contabil</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" id="list_justificativa-tab" data-toggle="tab" href="#list_justificativa" role="tab"
          aria-controls="list_justificativa" aria-selected="true">Justificativas</a>
      </li>
    </ul>
    <div class="tab-content" id="tab_content">
      <div class="tab-pane fade show active" id="encerramento" role="tabpanel" aria-labelledby="encerramento-tab">
        <form [formGroup]="entidadeForm">
          <div class="row mt-2">
            <div class="col-12">
              <p-message [style]="{'width': '100%'}" *ngIf="mesSelect && mesSelect.select" severity="info"
                text="Você marcou o mês de {{meses[mesSelect.mes]['nome']}} para ser encerrado, informe a justificativa e clique em salvar para encerrar o mes.">
              </p-message>
              <p-message [style]="{'width': '100%'}" *ngIf="mesSelect && !mesSelect.select" severity="info"
                text="Você desmarcou o mês de {{meses[mesSelect.mes]['nome']}} que já estava encerrado, informe a justificativa e clique em salvar, processo encaminhara um pendencia para setor contabil, depois de autorizado mês será automaticamente aberto.">
              </p-message>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="jan" type="checkbox" />
                  <span></span>
                  Janeiro
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="fev" type="checkbox" />
                  <span></span>
                  Fevereiro
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="mar" type="checkbox" />
                  <span></span>
                  Março
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="abr" type="checkbox" />
                  <span></span>
                  Abril
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="mai" type="checkbox" />
                  <span></span>
                  Maio
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="jun" type="checkbox" />
                  <span></span>
                  Junho
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="jul" type="checkbox" />
                  <span></span>
                  Julho
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="ago" type="checkbox" />
                  <span></span>
                  Agosto
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="set" type="checkbox" />
                  <span></span>
                  Setembro
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="out" type="checkbox" />
                  <span></span>
                  Outubro
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="nov" type="checkbox" />
                  <span></span>
                  Novembro
                </label>
              </div>
            </div>
            <div class="form-group col-md-2 m-3">
              <div class="checkbox checbox-switch switch-success">
                <label>
                  <input formControlName="dez" type="checkbox" />
                  <span></span>
                  Dezembro
                </label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="justificativa">Justificativa<span class="text-danger">*</span></label>
              <textarea #justificativa_ id="justificativa" formControlName="just" type="text"
                class="form-control">
            </textarea>
            </div>
          </div>
          <hr class="mt-1 mb-4" />
        </form>
      </div>
      <div class="tab-pane fade mt-3" id="list_justificativa" role="tabpanel" aria-labelledby="list_justificativa-tab">
        <lib-encerramento-contabil-justificativa-simples [(reload)]="reloadJust"  [parametros]="{'encerramento.id' : entidade.id}"></lib-encerramento-contabil-justificativa-simples>
      </div>
    </div>
  </div>
</div>